// @flow
import { useFormContext } from 'react-hook-form';

import { Checkbox, Text, View } from 'reshaped';

import { useTranslator } from '@gandi/translate';

import styles from './Checkbox.module.css';

type Props = {
  setChooseProductOwner: React.ReactSetStateFunction<boolean>,
};

export function BillingCheckbox({
  setChooseProductOwner,
}: Props): React.MixedElement | null {
  const { __ } = useTranslator();

  const form = useFormContext();

  const type = form.watch('type');

  function onChange({ checked }: { checked: boolean }) {
    setChooseProductOwner(!checked);
  }

  if (type === 'company') {
    return null;
  }

  return (
    <View>
      <View paddingBlock={4}>
        <Text variant="body-2" weight="bold">
          {__('Billing address')}
        </Text>
      </View>

      <View
        padding={4}
        border
        borderColor="neutral"
        borderRadius="large"
        className={styles.container}
      >
        {/* $FlowFixMe[prop-missing] */}
        <Checkbox defaultChecked name="billing" onChange={onChange}>
          <Text variant="body-2">
            {__('Billing informations are the same')}
          </Text>
        </Checkbox>

        <View className={styles.help}>
          <Text as="p" variant="caption-1" color="neutral-faded">
            {__('Simplifies setup and reduces the steps.')}
          </Text>
        </View>
      </View>
    </View>
  );
}
